import {IList} from "@components/Footer/Footer";

export const termsList: Array<IList> = [
    {
        title: "Skywind Holdings Limited is licensed and regulated in Great Britain by the Gambling Commission under account number 52261",
        isLink: true,
        href: "https://registers.gamblingcommission.gov.uk/52261"
    },
];
